module.exports = __webpack_public_path__ + "img/1.1c160659.png";